export const scrollTo = domElement => {
  const rect = domElement.getBoundingClientRect();
  const position = rect.top;
  window.scroll({ top: position, behavior: 'smooth' });
};
